import React, { createContext, useContext, useState } from "react";
import { getClassName } from "@sscs/utils";
import { ChevronDownIcon as MUIArrowDown, ChevronUpIcon as MUIArrowUp, } from "../../icons";
import { Button } from "../index";
import styles from "./page.module.scss";
const HeaderContext = createContext({
    isExpanded: false,
    onChange: () => { },
});
/**
 * A collapsible band seating between `Page.Header` and `Page.Filters` in the Page shell: a white
 * summary row with an optional toggle revealing detail. Compose `Page.ExpandableHeader` > `.Summary`
 * (always-visible row plus toggle) + `.Content` (mounted only when expanded); pass `expandLabel`
 * (and optional `collapseLabel`) to render the toggle, else the Summary is static. The parts are
 * context-free, so the band works identically outside `Page.Root` (the pinned report shell).
 */
const Container = ({ className, children, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (React.createElement(HeaderContext.Provider, { value: { isExpanded, onChange: setIsExpanded } },
        React.createElement("div", { className: getClassName(styles.expandable, { [styles["expandable-expanded"]]: isExpanded }, className) }, children)));
};
const Summary = ({ expandLabel, collapseLabel, className, children, }) => {
    const { isExpanded, onChange } = useContext(HeaderContext);
    return (React.createElement("div", { className: getClassName(styles["expandable-summary"], className) },
        children,
        expandLabel && (React.createElement(Button, { type: "button", color: "secondary", onClick: () => onChange(!isExpanded), className: styles["expand-action"] },
            isExpanded && collapseLabel ? collapseLabel : expandLabel,
            isExpanded ? React.createElement(MUIArrowUp, null) : React.createElement(MUIArrowDown, null)))));
};
const Content = ({ children }) => {
    const { isExpanded } = useContext(HeaderContext);
    if (!isExpanded) {
        return null;
    }
    return React.createElement("div", { className: styles["header-content"] }, children);
};
export default Object.assign(Container, { Summary, Content });
//# sourceMappingURL=ExpandableHeader.js.map